import { createContext, useContext, type ReactNode } from "react"

export interface DetailTheme {
    color: string
}

const defaultTheme: DetailTheme = {
    color: "#FFF",
}

const DetailThemeContext = createContext<DetailTheme>(defaultTheme)

export function useDetailTheme() {
    return useContext(DetailThemeContext)
}

interface DetailProviderProps {
    theme: Partial<DetailTheme>
    children: ReactNode
}

export function DetailProvider({ theme, children }: DetailProviderProps) {
    const merged: DetailTheme = { ...defaultTheme, ...theme }
    return (
        <DetailThemeContext.Provider value={merged}>
            {children}
        </DetailThemeContext.Provider>
    )
}
